export default __webpack_public_path__ + "static/media/343.046ab993.svg";